import type { OAuthProvider } from '@/shared/config/routes';
import { isOAuthProvider } from './oauth-message';

type OAuthReturn = { provider: OAuthProvider; cleanUrl: string };

/** After a redirect sign-in (the popup was blocked) the server sends people to /?oauth=<provider>&status=ok. */
export function readOAuthReturn(href: string): OAuthReturn | null {
  const url = new URL(href);
  const provider = url.searchParams.get('oauth');
  if (url.searchParams.get('status') !== 'ok' || !isOAuthProvider(provider)) return null;
  url.searchParams.delete('oauth');
  url.searchParams.delete('status');
  return { provider, cleanUrl: `${url.pathname}${url.search}${url.hash}` };
}
